import { ItemTypes } from '../constants/constants';

// Plage de containers/box/colonnes couverte par le titre niveau 1 ancré sur
// `startContainerId` (jusqu'au prochain titre niveau 1). Module feuille (pas
// d'import de utils/boxes ni de composants) : importable depuis structureLocks
// et testable sans tirer toute la chaîne react-dnd.
export const findTitleLevel1ContainerRange = ({
  containers,
  boxes,
  columns,
  startContainerId,
}) => {
  const emptyResult = {
    containersIncluded: [],
    boxesIncluded: [],
    columnsIncluded: [],
  };

  if (!startContainerId || !containers?.length || !boxes?.length) {
    return emptyResult;
  }

  const titleLevel1ColumnIds = new Set();
  for (const box of boxes) {
    if (box.type === ItemTypes.TITLE) {
      titleLevel1ColumnIds.add(box.columnId);
    }
  }

  if (titleLevel1ColumnIds.size === 0) {
    return emptyResult;
  }

  let visibleContainerIndex = -1;
  const titleLevel1Indices = [];

  for (let i = 0; i < containers.length; i++) {
    const container = containers[i];
    if (container.id === startContainerId) {
      visibleContainerIndex = i;
    }
    if (
      container.columnsIds.some((columnId) =>
        titleLevel1ColumnIds.has(columnId)
      )
    ) {
      titleLevel1Indices.push(i);
    }
  }

  if (visibleContainerIndex < 0 || titleLevel1Indices.length === 0) {
    return emptyResult;
  }

  let anchorTitleIndex = -1;
  for (let i = 0; i < titleLevel1Indices.length; i++) {
    if (titleLevel1Indices[i] <= visibleContainerIndex) {
      anchorTitleIndex = i;
    } else {
      break;
    }
  }

  if (anchorTitleIndex === -1) {
    // Aucun titre niveau 1 avant ou dans startContainerId, fallback sur le 1er titre
    anchorTitleIndex = 0;
  }

  const anchorContainerIndex = titleLevel1Indices[anchorTitleIndex];
  const nextTitleIndex =
    titleLevel1Indices[anchorTitleIndex + 1] ?? containers.length;
  const isFirstTitleLevel1 = anchorTitleIndex === 0;
  const startIndex = isFirstTitleLevel1 ? 0 : anchorContainerIndex;

  const containersIncluded = containers.slice(startIndex, nextTitleIndex);
  const columnIdsIncluded = new Set();
  for (const container of containersIncluded) {
    for (const columnId of container.columnsIds) {
      columnIdsIncluded.add(columnId);
    }
  }

  const columnsIncluded = columns?.length
    ? columns.filter((column) => columnIdsIncluded.has(column.id))
    : [];
  const boxesIncluded = boxes.filter((box) =>
    columnIdsIncluded.has(box.columnId)
  );

  return {
    containersIncluded,
    boxesIncluded,
    columnsIncluded,
  };
};
